<div class="table-row">
    <div class="row py-2 align-items-start" (click)="rowClick()">
        <div class="col-1 d-flex justify-content-center align-items-start">
            <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
        </div>

        <div class="col">
            <div class="row">
                <ng-container *ngFor="let column of columns; let i = index">
                    <div [ngClass]="['col-4', 'col-5', 'col-3'][i] || 'col'" class="text-break">
                        {{ get(column.field) }}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div *ngIf="!isCollapsed" class="py-3" [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }">
        <div class="row align-items-center my-2">
            <label class="col-12 col-md-3 text-start text-md-end col-form-label" for="techIdentNo">
                {{ technicalIdOrFunctionalLocationLabel }}
            </label>
            <div class="col-12 col-md-8">
                <pace-core-text-input
                    id="techIdentNo"
                    name="techIdentNo"
                    [(model)]="row.tidnr"
                    [parentForm]="formChildren"
                    (valueChange)="modelValueChanged($event)"
                    [ariaLabel]="technicalIdOrFunctionalLocationLabel"
                >
                </pace-core-text-input>
            </div>
        </div>
        <div class="row align-items-center my-2">
            <label
                class="col-12 col-md-3 text-start text-md-end col-form-label"
                for="materialNo"
                translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_EQUIPMENT_MATERIAL_ID"
            ></label>
            <div class="col-12 col-md-8">
                <pace-core-text-input
                    id="materialNo"
                    name="materialNo"
                    [(model)]="row.matnr"
                    [parentForm]="formChildren"
                    (valueChange)="modelValueChanged($event)"
                    [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_EQUIPMENT_MATERIAL_ID' | translate"
                >
                </pace-core-text-input>
            </div>
        </div>
        <div class="row align-items-center my-2">
            <label
                class="col-12 col-md-3 text-start text-md-end col-form-label"
                for="serialNo"
                translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_EQUIPMENT_SERIAL"
            ></label>
            <div class="col-12 col-md-8">
                <pace-core-text-input
                    id="serialNo"
                    name="serialNo"
                    [(model)]="row.sernr"
                    [parentForm]="formChildren"
                    (valueChange)="modelValueChanged($event)"
                    [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_EQUIPMENT_SERIAL' | translate"
                >
                </pace-core-text-input>
            </div>
        </div>
        <div class="row align-items-center my-2" *ngIf="displayReasonText">
            <label
                class="col-12 col-md-3 text-start text-md-end col-form-label"
                for="txtReason"
                translate="NOTIFICATION_DETAIL_DATA_MAINTENANCE_REASON"
            ></label>
            <div class="col-12 col-md-8">
                <pace-core-text-input
                    id="txtReason"
                    name="txtReason"
                    [(model)]="row.reasonText"
                    [parentForm]="formChildren"
                    (valueChange)="modelValueChanged($event)"
                    [ariaLabel]="'NOTIFICATION_DETAIL_DATA_MAINTENANCE_REASON' | translate"
                ></pace-core-text-input>
            </div>
        </div>
    </div>
</div>
